import { HISTORY_SKIP_PARAMS } from "./constants";

export const collectionHandleFromPath = (pathname: string) => {
  const match = pathname.match(/\/collections\/([^/?#]+)/);
  return match?.[1] ?? "";
};

export const appendNavParent = (url: URL, navParent?: string | null) => {
  const parent = navParent ?? new URL(window.location.href).searchParams.get("nav_parent");
  if (parent && !url.searchParams.has("nav_parent")) {
    url.searchParams.set("nav_parent", parent);
  }
};

export const mergeSearchParams = (target: URL, source: URL, skip: Set<string>) => {
  for (const [key, value] of source.searchParams.entries()) {
    if (skip.has(key)) continue;
    target.searchParams.append(key, value);
  }
};

export const buildSectionUrl = (rawUrl: string, sectionHandle: string, navParent?: string | null) => {
  const url = new URL(rawUrl, window.location.origin);
  url.searchParams.set("section_id", sectionHandle);
  if (navParent) url.searchParams.set("nav_parent", navParent);
  return url.toString();
};

export const buildUrlWithParams = (pathname: string, params: string, navParent?: string | null) => {
  const url = new URL(pathname, window.location.origin);
  if (params) {
    for (const [key, value] of new URLSearchParams(params).entries()) {
      url.searchParams.append(key, value);
    }
  }
  appendNavParent(url, navParent);
  return url;
};

export const buildDisplayUrl = (pathUrl: URL, navParent: string | null, skip: Set<string>) => {
  const displayUrl = new URL(pathUrl.pathname, window.location.origin);
  mergeSearchParams(displayUrl, pathUrl, skip);
  if (navParent) displayUrl.searchParams.set("nav_parent", navParent);
  return displayUrl;
};

export const getNavParentFromLocation = () => new URL(window.location.href).searchParams.get("nav_parent");

export const historyPathFromParams = (pathname: string, params: string) =>
  buildUrlWithParams(pathname, params).pathname + buildUrlWithParams(pathname, params).search;

export const mergeCurrentLocationIntoUrl = (pathname: string, search: string, skip: Set<string>) => {
  const merged = new URL(pathname, window.location.origin);
  mergeSearchParams(merged, new URL(search, window.location.origin), skip);
  return merged;
};

export const displayUrlFromPathAndSearch = (pathname: string, search: string, navParent: string | null) => {
  const pathUrl = new URL(pathname + search, window.location.origin);
  return buildDisplayUrl(pathUrl, navParent, HISTORY_SKIP_PARAMS);
};
